module.exports = __webpack_public_path__ + "static/media/Hanna Ansar Koloth.469d869c.jpg";